import React, { useContext, useEffect, useState, useMemo } from "react";
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography';
import { useNavigate, Link } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container'
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import '@fontsource/roboto/300.css';
import { useHistory } from 'react-router-dom';
import api from '../../services/api';
import { Cookies } from 'react-cookie';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { makeStyles } from '@mui/styles';
import LogoNafil from '../../assets/img/NAFIL_logo.svg';
import { formatarTelefone, formatarDataHora, numberWithCommas, identificacaoUsuarioLogado } from '../../utils';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import DetalhesMeusCupons from '../../components/MeusCupons/MeusCupons';
import Backdrop from '@mui/material/Backdrop';
import { MyContext } from '../../context/MyContext';
import * as locales from '@mui/material/locale';
import { useTheme, ThemeProvider, createTheme } from "@mui/material/styles";
import { DataGrid, GridColDef, GridSelectionModel } from '@mui/x-data-grid';
import Dialogo from '../Dialogo/Dialogo';
// import Checkbox from '@mui/material/Checkbox';

export default function (props) {
    const [open, setOpen] = useState(false);
    const [openMeusCupons, setOpenMeusCupons] = useState(false);
    const [meusCheques, setMeusCheques] = useState([]);
    const [locale, setLocale] = useState('ptBR');
    const theme = useTheme();
    const themeWithLocale = useMemo(() => createTheme(theme, locales[locale]), [locale, theme]);
    const [retornoApi, setRetornoApi] = useState({});
    const [usuarioLogado, setUsuarioLogado] = useState("");  // Armazena Criptografado o Id e Loja do Cliente
    const { meuCarrinho, setMeuCarrinho } = useContext(MyContext);
    const { showModalMeusCreditos, setShowModalMeusCreditos } = useContext(MyContext);
    const { meuEspecie, setMeuEspecie } = useContext(MyContext);
    const { meuCredito, setMeuCredito } = useContext(MyContext);    
    const { meuCreditoDetalhes, setMeuCreditoDetalhes } = useContext(MyContext); // Armazena os Dados dos Créditos a Serem utilizados no Ato de Pagamento    
    const [selectionModel, setSelectionModel] = React.useState(() => meuCredito);
    const [totalCreditosSelecionados, setTotalCreditosSelecionados] = useState(0.00);
    const [totalCreditosDisponiveis, setTotalCreditosDisponiveis] = useState(0.00);
    const [observacoesCredito, setObservacoesCredito] = useState("");
    const [openDialogo, setOpenDialogo] = useState(false);    
    const [dialogoMensagem, SetDialogoMensagem] = useState("");
    const [dialogoRetornoSim, setDialogoRetornoSim] = useState(false);
    const [selectedRows, setSelectedRows] = React.useState([]);
    const {showModalMeusCheques, setShowModalMeusCheques} = useContext(MyContext);

    let navigate = useHistory();

    const toastMensagemError = (message) => toast.error(message,
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

    useEffect(() => {
        setUsuarioLogado(sessionStorage.getItem("id_loja_usuario"));
        var userLogado = identificacaoUsuarioLogado(usuarioLogado);
        if (userLogado != null && userLogado.length == 0) {
            toastMensagemError("Será Necessário Efetuar Login!");
            navigate.push('/login');
        }
        else {            
            BuscarChequesDevolvidos(userLogado);
            // MARCAR o CHECKBOX do DATAGRID
            // setSelectionModel(meuCredito);
        }       
    }, []);   

    useEffect(() => {
        // VOLTAR AtualizaObservacoes(selectionModel);
    }, [selectionModel, totalCreditosSelecionados, open]);

    const handleCloseModal = (e) => {        
        setShowModalMeusCreditos(false);
        // navigate.push('/index');
    }

    const cancelarVisualizacaoChequesDevolvidos = (e) => {
        setShowModalMeusCheques(false);
        // navigate.push('/index');
    }
    const confirmarUtilizacaoCreditos = (e) => {        
        setMeuCredito(selectionModel);  // Somente ID dos Créditos
        setMeuCreditoDetalhes( meusCheques.filter((elem) => {
            return selectionModel.some((ele) => {
            return ele.split('-')[0] == elem.idsCreditos && ele.split('-')[1] == elem.idsCreditosLoja;
              })}) ); // Armazena os Dados dos Créditos a Serem utilizados no Ato de Pagamento
        setShowModalMeusCreditos(false);
    }    

    const modalStyle = {
        position: 'absolute',
        top: '20%',
        left: '10%',
        right: "10%",
        overflow: 'scroll',
        height: '100%',
        display: 'block',
        bgcolor: 'background.paper',
        boxShadow: 24
    }
    // , , data, total_geral, , transporte_modelo, transporte_data_saida

    const handleCloseNao = () => {
       // setDialogoProduto({});
        setDialogoRetornoSim(false);
        setOpenDialogo(false);
    };

    const handleCloseSim = () => {
        setSelectionModel([]);
        setDialogoRetornoSim(true);
        setOpenDialogo(false);
        handleCloseModal()
    };

    const AtualizaObservacoes = (selection) => {            
            setObservacoesCredito(selection.row.criadoObs);
    }

    const gridStyles = makeStyles((theme) => ({
        container: {
            border: '4px solid green',
            display: 'inline-flex',
        },
        item: { borderRadius: '30px' },
        paper: {
            padding: theme.spacing(2),
            textAlign: 'center',
            color: theme.palette.text.secondary,
        },
    }));

    const columns = [
        {
            field: 'meusCheques.ids_cheques + "-" + meusCheques.ids_loja_cheques',
            headerName: 'ID Cheque',
            width: 90,
            editable: false,
            valueGetter: (params) =>
                `${params.row.ids_cheques + "-" + params.row.ids_loja_cheques || ''}`,
        },
        {
            field: 'meusCheques.cpf_cnpj',
            headerName: 'CPF / CNPJ',
            width: 105,
            editable: false,
            valueGetter: (params) =>
                `${ params.row.cpf_cnpj.toString().substring(0,5) + params.row.cpf_cnpj.toString().substring(5).replace(/[0-9]/g, '*')   || ''}`,
        },
        {
            field: 'meusCheques.razao_social',
            headerName: 'Nome do Portador',
            width: 270,
            editable: false,
            valueGetter: (params) =>
                `${params.row.razao_social || ''}`,
        },
        {
            field: 'meusCheques.valor',
            headerName: 'Valor',
            width: 120,
            editable: false,
            align: 'right',
            valueGetter: (params) =>
                `${numberWithCommas(params.row.valor) || ''}`,
        },
        {
            field: 'meusCheques.pre_datado',
            headerName: 'Pré-Datado',
            width: 135,
            editable: false,
            valueGetter: (params) =>
                `${formatarDataHora(params.row.pre_datado,0) + " " || ''}`,
        },
        {
            field: 'meusCheques.aliena',
            headerName: 'Alínea',
            width: 45,
            editable: false,
            valueGetter: (params) =>
                `${(params.row.aliena || '')}`,
        },
        {
            field: 'meusCheques.motivo',
            headerName: 'Motivo',
            width: 255,
            editable: false,
            valueGetter: (params) =>
                `${(params.row.motivo || '')}`,
        },

        // // ADICIONA DOIS CHECKBOX NO DATAGRID
        // {
        //     field: 'meusCreditos.utilVenda',
        //     headerName: 'Xuxu',
        //     width: 150,            
        //     editable: false,
        //     renderCell: (params) => (
        //         (
        //             params.id != "7-1" ? 
        //         <Checkbox
        //           // checked={selectionModel.includes(params.id) || false}
        //           disableRipple
        //           disableFocusRipple
        //           onCellClick={(parametros) => AtualizaObservacoes(parametros)}
        //           value={(parametros) => (selectionModel.has(parametros.id) ? true : false )}
        //         />
        //         :
        //         <></>
        //         )
        //       ),
        //     valueGetter: (params) =>
        //         `${(params.row.utilVenda == null ? "" : params.row.utilVenda + "-" + params.row.utilVendaLoja || '')}`,
        // },
    ];

    function BuscarChequesDevolvidos(usuarioLogado) {
        var __clienteID = 0;
        var __clienteIDLoja = 0;
        __clienteID = usuarioLogado.split('_')[0];
        __clienteIDLoja = usuarioLogado.split('_')[1];
        api.get(`Cheques/ChequesDevovidos/${__clienteID}/${__clienteIDLoja}`)
            .then((data) => {
                setMeusCheques(data.data);
                // setSelectedRows(meuCredito);
            })
            .catch((error) => {
                if (error == "Error: Network Error") {
                    toastMensagemError("Ops, Alguma Coisa Errada com Nosso Servidor!");
                    return null;
                }
                console.log(error.message)
            });
    }

    const localizedTextsMap = {
        columnMenuUnsort: "Não Ordenado",
        columnMenuSortAsc: "Ordem Crescente",
        columnMenuSortDesc: "Ordem Cecrescente",
        columnMenuFilter: "Filtro",
        columnMenuHideColumn: "Ocultar",
        columnMenuShowColumns: "Mostrar Colunas",
        columnHeaderSortIconLabel: 'Ordenar',
        noRowsLabel: 'Nenhum Cheque Devolvido',
        footerTotalRows: 'Total de Linhas:',
        filterPanelOperators: 'Operador',
        filterPanelColumns: 'Coluna',
        filterPanelInputLabel: 'Valor',
        filterOperatorContains: 'contém',
        filterOperatorEquals: 'igual',
        filterOperatorStartsWith: 'começa com',
        filterOperatorEndsWith: 'termina com',
        filterOperatorIs: 'é',
        filterOperatorNot: 'não é',
        filterOperatorAfter: 'depois de',
        filterOperatorOnOrAfter: 'igual ou depois',
        filterOperatorBefore: 'antes de',
        filterOperatorOnOrBefore: 'igual ou antes',
        filterOperatorIsEmpty: 'é vazio',
        filterOperatorIsNotEmpty: 'não é vazio',
        filterOperatorIsAnyOf: 'é qualquer um',
        filterPanelInputPlaceholder: 'Pesquisar',
        toolbarFiltersTooltipActive: (count) =>
            count !== 1 ? `${count} filtro ativo` : `${count} filtros ativos`,
        footerTotalVisibleRows: (visibleCount, totalCount) =>
            `${visibleCount.toLocaleString()} de ${totalCount.toLocaleString()}`,

        footerRowSelected: (count) =>
            count !== 1
                ? `${count.toLocaleString()} Créditos Selecionados`
                : `${count.toLocaleString()} Crédito Selecionado`,
    };

    return (
        (meusCheques == null && openMeusCupons == true
            ?
            <></>
            :
            <div>
                <Container maxWidth="lg">
                    <Box marginTop={'10px'}>
                        <Grid container>
                            <Grid
                                item
                                xs={12}
                                align="center"
                                borderRadius={'4px'}
                                style={{ border: "1px solid #e2e2e2", borderBottomLeftRadius: "0px", borderBottomRightRadius: "0px" }}
                            >
                                <Typography sx={{ bgcolor: "#EAFAF1" }}>Meus Cheques Devolvidos</Typography>
                            </Grid>                            
                        </Grid>
                    </Box>

                    <Box>
                        <Grid container justifyContent={"center"} spacing={2}>

                            <Grid item xs={12} md={12} classeName={gridStyles}>
                                <div>
                                    <ThemeProvider theme={themeWithLocale}>
                                        <DataGrid
                                            headerHeight={35}
                                            // autoHeight
                                            getRowId={(mCredito) => mCredito.idsCreditos + '-' + mCredito.idsCreditosLoja}
                                            rows={meusCheques}
                                            onStateChange={(state) => {
                                                let _totalMarcados = 0.00;
                                                for (var x = 0; x < state.selection.length; x++) {
                                                    _totalMarcados += meusCheques.filter((item) => item.idsCreditos == state.selection[x].split('-')[0] && item.idsCreditosLoja == state.selection[x].split('-')[1]).map((item) => item.valor).reduce((a, b) => a + b, 0)
                                                }
                                                setTotalCreditosSelecionados(_totalMarcados);
                                                const _totalDisponivel = meusCheques.filter((item) => item.utilData == null).map((item) => item.valor).reduce((a, b) => a + b, 0);
                                                setTotalCreditosDisponiveis(_totalDisponivel);
                                            }}
                                            isRowSelectable={(params) => params.row.utilData == null}
                                            columns={columns}
                                            pageSize={20}
                                            rowHeight={34}
                                            // checkboxSelection
                                            selectionModel={selectionModel}
                                            disableSelectionOnClick
                                            // hideFooterSelectedRowCount
                                            onCellClick={(selection) => {
                                                AtualizaObservacoes(selection);
                                            }}
                                            onSelectionModelChange={(selection) => {
                                                setSelectionModel(selection);
                                            }}
                                            localeText={localizedTextsMap}
                                            sx={{ fontSize: '12px', fontWeight: 'bold', borderTopLeftRadius: '0px', borderTopRightRadius: '0px', minHeight: '430px' }}
                                        />
                                    </ThemeProvider>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box>
                        <Grid container direction="row" justifyContent="space-around" alignItems="center" spacing={10} marginBottom={'100px'}>
                            <Grid item xs={2} md={2}>
                                <Button onClick={() => cancelarVisualizacaoChequesDevolvidos() } variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop:'10px', minWidth:'103px' }}>Cancelar</Button>
                            </Grid>

                            <Grid item xs={2} md={2}>
                                <Button onClick={() => confirmarUtilizacaoCreditos()}  disabled={ selectionModel.length == 0 } disableElevation variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop:'10px', minWidth:'103px' }}>Utilizar</Button>
                            </Grid>

                        </Grid>
                    </Box>
                </Container>                

                <ToastContainer />
                {
                    (open ?
                        <div>
                            <Modal
                                aria-labelledby="transition-modal-title"
                                aria-describedby="transition-modal-description"
                                open={open}
                                // onClose={handleCloseModal}
                                closeAfterTransition
                                BackdropComponent={Backdrop}
                                BackdropProps={{
                                    timeout: 500,
                                }}
                            >
                                <Fade in={open}>
                                    <Box sx={modalStyle}>
                                        <DetalhesMeusCupons props={retornoApi} />
                                    </Box>
                                </Fade>
                            </Modal>
                        </div>
                        :
                        <div></div>)
                }
            </div >
        )
    )
}
